import { Modal } from "antd";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { closeImageUploadPopup } from "../../redux/chat.slice";
import { ChatMessageImageUploadPopupContent } from "./chat-message-image-upload-popup-content";
import { useEffect, useState } from "react";


export function ChatMessageImageUploadPopup() {
  const open = useAppSelector(state => state.chat.imageUploadPopup.open);
  const dispatch = useAppDispatch();

  const [key, setKey] = useState(0);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    setKey(k => k +1);
  }, [open]);

  const handleClose = () => {
    if (uploading) {
      return
    }
    dispatch(closeImageUploadPopup())
  }

  return <Modal
    open={open}
    footer={null}
    onCancel={handleClose}
    title="Upload Image"
  >
    <div style={{ margin: '20px 0' }}>
      {
        open && <ChatMessageImageUploadPopupContent 
          uploading={uploading}
          setUploading={setUploading}
          key={key}
        />
      }
    </div>
  </Modal>
}

